export const RAF_TNC_PATH = '/promotions/friend-referral/refer-a-friend/'
export const RAF_TNC_LINK = `https://www.vtmarkets.com${RAF_TNC_PATH}`
export const RAF_INDIA_TNC_LINK = 'https://www.vtmarkets.com/vt-markets-refer-a-friend-promotion/'
export const GOLD_TRADING_IOS_APP_LINK = 'https://apps.apple.com/au/app/vt-markets-gold-trading/id1372647263'
export const GOLD_TRADING_ANDROID_APP_LINK = 'https://play.google.com/store/apps/details?id=cn.com.vtmarkets'
export const PROTRADER_HOWTOTRADE_LINK = 'https://howtotrade.com/vtmarkets/sign/'
export const LOYALTY_PROGRAMME_COMMON_TNC_LINK = 'https://www.vtmarkets.com/clubbleu_general_tc'
